import { render, staticRenderFns } from "./list-of-colors.vue?vue&type=template&id=1f992a5c&scoped=true"
import script from "./list-of-colors.vue?vue&type=script&lang=js"
export * from "./list-of-colors.vue?vue&type=script&lang=js"
import style0 from "./list-of-colors.vue?vue&type=style&index=0&id=1f992a5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f992a5c",
  null
  
)

export default component.exports